import { render } from "./AccessibleEnvironmentView.vue?vue&type=template&id=6d60f0f8&scoped=true"
import script from "./AccessibleEnvironmentView.vue?vue&type=script&lang=js"
export * from "./AccessibleEnvironmentView.vue?vue&type=script&lang=js"

import "./AccessibleEnvironmentView.vue?vue&type=style&index=0&id=6d60f0f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d60f0f8"]])

export default __exports__